// extracted by mini-css-extract-plugin
module.exports = {"newsDetails":"NewsDetailsStyle_newsDetails__3Azir","btn":"NewsDetailsStyle_btn__16Sti","desc":"NewsDetailsStyle_desc__1HDOl","info":"NewsDetailsStyle_info__2N14G"};